<script setup>
import { computed } from 'vue';
import {parseCellFormatting} from "@/tariffs/cell_formatters";

const props = defineProps({
    cell: {
        type: Object,
        default: () => {
            return {
                content: '888',
                formatFunc: (value) => {
                    return `${value}!!`;
                },
            };
        },
    },
});

const cellIsComputed = computed(() => {
    if (!props.cell || !props.cell.content) {
        return false;
    }
    return props.cell.content['value'] !== undefined;
});

const cellContent = computed(() => {
    return parseCellFormatting(props.cell);
});
</script>

<template>
    <span :class="cellIsComputed ? 'font-semibold' : ''">
        {{ cellContent }}
    </span>
    <div class="font-light">{{ props.cell.label }}</div>
</template>
